import { SET_REPORT_ANALYTICS_DATE_RANGE } from 'constants/ActionTypes';
import { DATE_RANGES } from 'features/orderHistory/components/filters/commonComponents/dateRangeFilter/DateFilter.utils';
import DateRangeFilter from 'features/orderHistory/components/filters/commonComponents/dateRangeFilter/DateRangeFilter.component';
import React from 'lib/react';
import { useDispatch, useSelector } from 'lib/redux';

function DateFilter() {
  const dispatch = useDispatch();
  const {
    startDate, endDate, dateError, selectedDateOption,
  } = useSelector(({ analyticsDashboard }) => analyticsDashboard.reportAnalyticsFilters);

  const handleDateChange = (event) => {
    const { target: { id, value } } = event;
    dispatch({
      type: SET_REPORT_ANALYTICS_DATE_RANGE,
      [id]: value,
      selectedDateOption: DATE_RANGES.CUSTOM,
    });
  };

  const handleDateRangeOptionChange = (dateValues, optionValue) => {
    dispatch({
      type: SET_REPORT_ANALYTICS_DATE_RANGE,
      startDate: dateValues[0],
      endDate: dateValues[1],
      selectedDateOption: optionValue,
    });
  };
  return (
    <DateRangeFilter
      startDate={startDate}
      endDate={endDate}
      dateError={dateError}
      selectedDateOption={selectedDateOption}
      handleDateChange={handleDateChange}
      handleDateRangeOptionChange={handleDateRangeOptionChange}
    />
  );
}

export default DateFilter;
